<template>
    <div :class="{'ly-is-full':isFull}" class="wrapper-dev">

       
        <div class="devicemanage_class_1">
            <!-- <div  class="dev-table-title2" ref="tableSelect11" ></div> -->
            <div style="display: flex;justify-content: space-between;align-items: stretch;height: 100%;padding: var(--my-css-var-bg-padding)" >
                <div class="devicemanage_tree" >
                
                    <el-tree ref="tree" :data="treeData"  :default-expand-all="true" @node-click="handleNodeClick">
                        <template v-slot="{ node, data }">
                        <span class="custom-tree-node" :title="node.label">
                        {{ node.label }}
                        </span>
                    </template>



                    </el-tree>
                </div>
                <div class="tableSelect devicemanage_table" >
                    <div ref="tableSelect3">
                        <el-form :inline="true" :model="formInline" label-position="left">
                            <!-- <el-form-item label="设备类型：">
                                <el-select v-model="formInline.group_type" placeholder="请选择" size="default" clearable  style="width:200px">
                                    <el-option
                                        v-for="item in deviceTypeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item> -->
                        
                            <el-form-item label="设备名称：">
                                <el-input size="default" v-model.trim="formInline.deviceName" maxlength="30" placeholder="设备名称" clearable  style="width:200px;"></el-input>
                            </el-form-item>
                            <el-form-item label="测点类型：" >
                                <!-- <el-input size="default" v-model.trim="formInline.sensorname" maxlength="30" placeholder="设备名称" clearable  style="width:200px;"></el-input> -->
                                <el-select v-model="formInline.type" placeholder="请选择" size="default" clearable  style="width:200px">
                                    <el-option
                                        v-for="item in sensorTypeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="工段：">
                                <el-input size="default" v-model.trim="formInline.workshop_section" maxlength="30" placeholder="请输入工段" clearable  style="width:200px;"></el-input>
                            </el-form-item>


                            <el-button  @click="search" type="primary" icon="Search" style="margin-left: 40px;">查询</el-button>
                            <el-button  @click="handleEdit('','reset')" icon="Refresh" style="margin-left: 40px;">重置</el-button> 

                        </el-form>                                      
                    </div>

                    <div class="table-data">
                        <el-table  border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%; margin-top: 16px;">
                            <el-table-column type="index" width="60" align="center" label="序号">
                                <template #default="scope">
                                    <span v-text="getIndex(scope.$index)"></span>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="100" prop="device_name" label="设备名称"  align="left"></el-table-column>
                            <!-- <el-table-column min-width="100" prop="group_type" label="设备类型" show-overflow-tooltip align="left"></el-table-column> -->
                            <el-table-column min-width="100" prop="name" label="测点名称"  align="left"></el-table-column>
                            <el-table-column min-width="80" prop="branch_factory" label="分厂"  align="left"></el-table-column>
                            <el-table-column min-width="100" prop="workshop_section" label="工段" align="left"></el-table-column>
                            <el-table-column min-width="80" prop="axis_type" label="轴类型"  align="left"></el-table-column>
                            <el-table-column min-width="120" prop="sn" label="传感器ID"  align="left"></el-table-column>
                            
                            <el-table-column min-width="120" prop="" label="额定电流"  align="left">
                                <template #default="{row}">
                                    <el-input-number v-model="row.rated_current" size="small" :precision="1" :step="0.5"  :min="0" class="custom-size" :disabled="row.type !=2"/> 
                                </template>
                            </el-table-column>
                            <el-table-column min-width="120" prop="" label="停机阈值"  align="left">
                                <template #default="{row}">
                                    <el-input-number v-model="row.stopped_threshold" size="small" :precision="1" :step="0.5"  :min="0" class="custom-size" /> 
                                </template>
                            </el-table-column>
                            <el-table-column min-width="120" prop="" label="高报"  align="left">
                                <template #default="{row}">
                                    <el-input-number v-model="row.warning_alarm_threshold" size="small"  :precision="1" :step="0.5"  :min="0" class="custom-size" /> 
                                </template>
                            </el-table-column>
                            <el-table-column min-width="120" prop="" label="高高报"  align="left">
                                <template #default="{row}">
                                    <el-input-number v-model="row.fatal_alarm_threshold" size="small"  :precision="1" :step="0.5"  :min="0" class="custom-size"/>
                                        
                                </template>
                            </el-table-column>
                            <el-table-column min-width="120" prop="" label="温度"  align="left" >
                                <template #default="{row}">
                                    <el-input-number v-model="row.warning_temperature_threshold"  :precision="1" :step="0.5"  size="small"  :min="0" class="custom-size" :disabled="row.type==2"/>
                                        
                                </template>
                            </el-table-column>
                         
                         
                         
                            <el-table-column label="操作"   fixed="right" width="90" align="left">
                                <template #default="{row}">
                                
                                    <el-button type="primary" @click="setting(
                                    row.id,
                                    row.stopped_threshold,
                                    row.rated_current,
                                    row.warning_alarm_threshold,
                                    row.fatal_alarm_threshold ,
                                    row.warning_temperature_threshold,
                                    row.sn,
                                    row.device_name)">设置</el-button>
                                  
                                </template>
                            </el-table-column>
                        </el-table>  
                    </div>
                    <div>
                        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
                    </div>
                </div>
            </div>

        </div>
  
    </div>
</template>

<script>
    import {apiDevice,apiSensorlist,apisensorsUpdate} from '@/api/api'
    import Pagination from "@/components/Pagination";
    import {dateFormats,getTableHeight} from "@/utils/util";
    import LyGrowcard from "@/components/analysis/growCard";
   
    import deviceTypeConfig from "@/config"
    
    export default {
        name: "rulesSet",
        components:{
            Pagination,
         
            LyGrowcard
        },
        data() {
            return {
                num:1,
                isFull:false,
                treeHighLightFlag:true,
                tableHeight:600,
                divHeight:500,
                loadingPage:false,
                showOtherSearch:false,//隐藏过长的搜索条件
                formInline:{
                    deviceName: null,
                    sensorname: null,
                    deviceType: null,
                    type:null,
                    workshop_section:null,
                   
                },
                pageparm: {
                    page: 1,
                    page_size: 10,
                    total: 0
                },
                tableData:[],
              
                deviceInfo:{
                    total:null,
                    online:null,
                    offline:null,
                    stopped:null,
                    fault:null
                },
                treeData: [
                    {
                        label: '内蒙古宜化化工有限公司',
                        children: [
                            {label: deviceTypeConfig.DEVICE_TYPE_1,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_2,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_3,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_4,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_5,children: [] },
                            {label: deviceTypeConfig.DEVICE_TYPE_6,children: [] }
                        ]
                    }       
                ],
                deviceTypeList:[
                    {id:0,name:'全部'},
                    {id:1,name:"重点设备"},
                    {id:2,name:"大型机组"},
                   
                   
                ],
                sensorTypeList:[
                    {id:1,name:'振动传感器'},
                    {id:2,name:'电流传感器'},
                                
                ],

                fntableParm:{
                    page: 1,
                    page_size: 10,
                    // ordering: "-device__status,device__name",
                    group_type: null,
                    name: null,
                    type: null,
                    device_name : null,
                    workshop_section_exact : null,     
                   
                },
                //route
                route_para :{
                    deviceType : 0,
                    flag : false ,
                }
            }
        },

        methods:{
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.page_size + $index +1
            },
            handleEdit(row,flag) {
                let vm = this
                if(flag=='delete') {
                    vm.$confirm('您确定要删除选中的数据吗？' ,{
                        closeOnClickModal:false
                    }).then(res=>{
                        //现在的DELETE命令，通过代理不能收到响应！？                       
                        apiSensorDelete({id:row.id}).then(res=>{
                            this.$message.success("删除传感器成功")
    
                            vm.search()
                            vm.getTreeData()
                        }) .catch(res => {  
                            console.log(res)
                            this.$message.warning(`删除传感器失败 : ${res.message}`)
                        });

                    }).catch(()=>{

                    })
                }
                else if(flag=="reset"){
                    this.fntableParm = {
                        page:1,
                        page_size: 10,
                        // ordering: "-device__status,device__name",
                    }
                    this.pageparm={
                        page: 1,
                        page_size: 10,
                        total: 0
                    }
                    this.treeHighLightFlag = false
                    this.formInline.deviceName = null
                    this.formInline.sensorname = null
                    this.formInline.group_type = null
                    this.formInline.type = null
                    this.formInline.workshop_section = null
                    
                    this.getData()
                }
            },

            callFather(parm) {
                this.fntableParm.page = parm.page
                this.fntableParm.page_size = parm.page_size
                // this.fntableParm.ordering = "-device__status,device__name"
                this.getData()
            },

            search() {
                this.pageparm.page = 1
                this.fntableParm.page = this.pageparm.page
                this.fntableParm.page_size = this.pageparm.page_size
               

                this.fntableParm.device_name = this.formInline.deviceName
                this.fntableParm.workshop_section_exact = this.formInline.workshop_section
             
                
                if(this.formInline.group_type == null || this.formInline.group_type ==0)
                  {
                    this.fntableParm.group_type = null
                  }
                else{
                    this.fntableParm.group_type = this.formInline.group_type
                }
             
                if(this.formInline.type == null || this.formInline.type ==0)
                  {
                    this.fntableParm.type = null
                  }
                else{
                    this.fntableParm.type = this.formInline.type
                }
                    
                
                // this.fntableParm.ordering = "-device__status,device__name"

                this.treeHighLightFlag = false
                this.getData()
            },

             getTreeData() {
               
                apiDevice().then(res=>{
                    if(res.data.code ==200) {

                        this.treeData = [{
                            label: '内蒙古宜化化工有限公司',
                            //children:[]
                            children: [
                                {label: deviceTypeConfig.DEVICE_TYPE_1,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_2,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_3,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_4,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_5,children: [] },
                                {label: deviceTypeConfig.DEVICE_TYPE_6,children: [] }
                            ]
                        }]

                        let factory = [
                            deviceTypeConfig.DEVICE_TYPE_1,
                            deviceTypeConfig.DEVICE_TYPE_2,
                            deviceTypeConfig.DEVICE_TYPE_3,
                            deviceTypeConfig.DEVICE_TYPE_4,
                            deviceTypeConfig.DEVICE_TYPE_5,
                            deviceTypeConfig.DEVICE_TYPE_6
                        ]
                        for(let i =0;i<res.data.data.total;i++){
                                let index =  factory.indexOf(res.data.data.items[i].branch_factory)
                                if(index == -1)
                                    continue;
                                let node = this.treeData[0].children[index]
                                let find_flag = 0
                                let j = 0;
                                for(j = 0; j < node.children.length ;j++){
                                    if(node.children[j].label == res.data.data.items[i].workshop_section){
                                        find_flag = 1
                                        break;
                                    }
                                }
                                if(find_flag == 1){
                                    this.treeData[0].children[index].children[j].children.push({
                                        label: res.data.data.items[i].name,
                                    });
                                }else{
                                    this.treeData[0].children[index].children.push({  
                                        label: res.data.data.items[i].workshop_section,  
                                        children: []  
                                    }); 
                                    this.treeData[0].children[index].children[this.treeData[0].children[index].children.length - 1].children.push({  
                                        label: res.data.data.items[i].name,  
                                    }); 
                                }
                            
                        }
                    }
                }) .catch(error => {  
                    if(error.msg)
                        this.$message.warning(`获取设备列表失败 : ${error.msg}`);  
                    else if(error.message)
                        this.$message.warning(`获取设备列表失败 : ${error.message}`);  
                    else 
                        this.$message.warning(`获取设备列表失败`); 
                });
             
            },

 
            dataChange(items){
                this.tableData.length = 0
                for(let i = 0;i<items.length;i++){
                    this.tableData[i] = items[i]
                    switch(items[i].group_type){
                        case 1:  this.tableData[i].group_type="重点设备" ;break;
                        case 2:  this.tableData[i].group_type="大型机组";break;
                        default: this.tableData[i].group_type="未知" ;break;
                    }
                    if(this.tableData[i].type ==1){
                        switch(items[i].axis_type){
                        case 1:  this.tableData[i].axis_type="单轴" ;break;
                        case 3:  this.tableData[i].axis_type="三轴";break;
                        default: this.tableData[i].axis_type="未知" ;break;
                    }
                    }else{
                        this.tableData[i].axis_type = '--'
                    }
                   
                 
                    this.tableData[i].warning_alarm_threshold = Number(items[i].warning_alarm_threshold)
                    this.tableData[i].fatal_alarm_threshold = Number(items[i].fatal_alarm_threshold)
                    this.tableData[i].battery = Number(items[i].battery)
                 
                }       
            },

            getData(){
                this.loadingPage = true
                this.tableData.length = 0;

                apiSensorlist(this.fntableParm).then(res => {
                    this.loadingPage = false
                  
                    if(res.data.code ==200) {
                      
                        this.dataChange(res.data.data.items)
                        this.pageparm.total = res.data.data.total;
                        let { page, page_size } = res.config.params 
                        this.pageparm.page = page    
                        this.pageparm.page_size = page_size  
                    }else{
                        this.$message.error(res.data.msg)
                    }
                 }) .catch(res => {  
                    this.loadingPage = false
                    this.$message.warning(`获取信息失败 : ${res.msg}`)
                });  
            },
            setting(
                id,
            stopped_threshold,
            rated_current,
            warning_alarm_threshold,
            fatal_alarm_threshold,
            warning_temperature_threshold,
            sn,device_name,
            ){
                 let params = {
                    id,
                    stopped_threshold,
                    rated_current,
                    warning_alarm_threshold,
                    fatal_alarm_threshold,
                    warning_temperature_threshold,
                  
                    sn,
                    device_name,
                    
                 }
                 this.loadingPage = true
                apisensorsUpdate(params).then(res =>{

                    this.loadingPage = false
                    
                    
                    if(res.code ==200) {
                      this.getData();
                      this.$message.success("设置成功") 
                    //   this.dataChange(res.data.data.items)
                    //   this.pageparm.total = res.data.data.total;
                    //   let { page, page_size } = res.config.params 
                    //   this.pageparm.page = page    
                    //   this.pageparm.page_size = page_size  
                    
                    }else{
                      this.$message.error("设置失败")
                  }

                }).catch(error =>{
                  
                    
                    this.loadingPage = false
                    this.$message.warning(`获取信息失败`)
                })
              
            },
    
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    // this.getTheTableHeight()
				})
			},

            // getTheTableHeight(){
            //     var bg_padding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--my-css-var-bg-padding'));
            //     var offsetHeight_sum = this.$refs.tableSelect1.offsetHeight + this.$refs.tableSelect2.offsetHeight + this.$refs.tableSelect3.offsetHeight +this.$refs.tableSelect11.offsetHeight
            //     this.tableHeight =  getTableHeight(offsetHeight_sum) -30 - 2 * bg_padding

            //     var offsetHeight_sum1 = this.$refs.tableSelect1.offsetHeight + this.$refs.tableSelect2.offsetHeight + this.$refs.tableSelect11.offsetHeight
            //     this.divHeight =  getTableHeight(offsetHeight_sum1,false) -130 - 2 * bg_padding
            // },

            checkTailNode(node,label){
                if('children' in node){
                    for(let index = 0;index < node.children.length;index++){
                        if(this.checkTailNode(node.children[index],label) == true)
                            return true
                    }
                }else{
                    if(node.label == label){
                        console.log(`find already : ${node.label} is key`)
                        return true
                    }
                }
                return false
            },
            handleNodeClick(node) {
                this.treeHighLightFlag = true
                if(!('children' in node)){
                  
                    this.pageparm.page = 1
                    this.pageparm.page_size = 10
                    this.pageparm.total = 0
                    this.fntableParm = {
                        device_name : node.label,
                        page : this.pageparm.page,
                        page_size : this.pageparm.page_size,
                        // ordering : "-device__status"
                    }

                    this.formInline.deviceName = node.label
                    this.formInline.deviceState = null
                    this.formInline.deviceType = null
                    this.formInline.deviceGroup = null
                    
                    this.getData()  
                }
            },






            refreshAllData(){
                this.search()
                this.getTreeData()
            },

        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
            //   this.getTheTableHeight()
            })
        },
        unmounted() {
              // 页面销毁，去掉监听事件
            window.removeEventListener("resize", this.listenResize);
        },
        created() {
            if(this.$route.query.type){
                this.route_para.deviceType = this.$route.query.type
                this.route_para.flag = true
                this.formInline.deviceType = parseInt(this.route_para.deviceType)
            } else {
                this.route_para.flag = false
            } 

            this.getTreeData()
            if(this.route_para.flag){
                this.fntableParm = {
                    page : this.pageparm.page,
                    page_size : this.pageparm.page_size,
                    device_type : this.route_para.deviceType,
                   
                }
            }else{
                this.fntableParm = {
                    page : this.pageparm.page,
                    page_size : this.pageparm.page_size,
                    
                }                
            } 
            this.getData()
        },
    }
</script>

<style lang="scss" scoped>

    .wrapper-dev{
        height: calc(100vh);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    
    .devicemanage_class_1{
        margin-top: 10px;
        height: 90%;
        width: 100%;
        background: url("@/assets/bigscreen/block_bg.jpg") no-repeat;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
     
     
    }
    .devicemanage_tree{
        background: var(--l-searchtoolbar-bg);
        box-shadow: var(--el-box-shadow-light);
        border: 1px solid var(--el-border-color-lighter);
        flex-grow: 0;
        height: 94%;
        width: 14%;
        padding-right: 20px;  
        overflow-y: auto; 
    
        margin-bottom: 7px;
        .el-tree {
            overflow-x: auto; /* 显示横向滚动条 */
           
            }
        .custom-tree-node{
            width: 100%;
            overflow: hidden; /* 超出部分隐藏 */
            white-space: nowrap; /* 禁止自动换行 */
            text-overflow: ellipsis; /* 使溢出部分以省略号显示 */
            display: block; /* 确保样式生效 */ 
        }
      
    }

    .devicemanage_table{
        flex-grow: 1;
        margin-left: 10px;
        height: 91%;
        // margin-top: 7px;
        // margin-right: 5px;
        overflow-x: auto;
        .table-data{
            height: 86%;
           
        }
       
    }

    .dev-table-title {
        position: relative;
        left: 2%; 
        font-size: 15px; 
        font-weight: bold; 
        color: #fff; 
        padding-top: 0.6%;
        padding-left: 1%;
    }

    .dev-table-title2 {
        position: relative;
        font-size: 15px; 
        font-weight: bold;
        color: #fff;
        padding-top: 12px;
        padding-bottom: 7px;
        height: 18px;
        padding-left: 3%;
        background: url("@/assets/bigscreen/device_head_bg.png"),url("@/assets/bigscreen/device_head_bg2.png") ;
        background-repeat: no-repeat, no-repeat;  
        background-position: center, 1% 50%;
        background-size: 100% 100%, auto;;
    }

    :deep(.custom-size){
        height: 30px; /* 自定义高度 */
        width: 100px; /* 自定义宽度 */
        line-height: 30px; /* 调整行高以垂直居中 */
        font-size: 16px; /* 字体大小 */
    }
 
</style>